import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const About = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      id="about"
      className="py-24 md:py-32 bg-cream"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          {/* Image */}
          <motion.div
            ref={ref}
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1554048612-b6a482bc67e5?w=800&q=80"
                alt="Photographer at work"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 border border-terracotta hidden md:block" />
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <p className="font-sans text-xs tracking-superwide text-terracotta mb-4">
              ABOUT US
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl text-charcoal mb-8 leading-tight">
              We're <span className="italic">creatives</span> at heart, driven by <span className="italic">purposeful</span> vision
            </h2>
            <div className="space-y-6 font-body text-base text-stone leading-relaxed">
              <p>
                Based in Canada, Alita Captures is a boutique photography and videography studio specializing in weddings, portraits, and brand storytelling.
              </p>
              <p>
                With a keen eye for detail and a passion for authentic moments, we transform fleeting memories into timeless visual narratives. Our approach blends artistry with intentionality, ensuring every frame reflects the true essence of your story.
              </p>
              <p>
                From intimate celebrations to grand events, we're dedicated to capturing the emotions and beauty that make your moments unforgettable.
              </p>
            </div>
            <div className="mt-10 flex gap-12">
              <div>
                <p className="font-serif text-4xl text-charcoal">8+</p>
                <p className="font-sans text-xs tracking-widest text-stone mt-1">YEARS EXPERIENCE</p>
              </div>
              <div>
                <p className="font-serif text-4xl text-charcoal">500+</p>
                <p className="font-sans text-xs tracking-widest text-stone mt-1">PROJECTS COMPLETED</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
